const TagType = {
  selfReported: 'selfReported',
  idVerified: 'idVerified',
  incomeVerifiedByFinicity: 'incomeVerifiedByFinicity',
  notIdVerified: 'notIdVerified',
};

export default TagType;
